<div class="errors">
    @if (epcotEnable) {
        <ms-epcot-notification [message]="message" [notificationType]="severity" />
    } @else {
        <div class="error">
            <vn-icon class="error-info" size="13" name="{{ getIconName }}" />
            <span class="gap-from-icon" [innerHtml]="message"></span>
        </div>
    }

    @if (links) {
        <div class="list list-card">
            <ms-list-item
                icon="theme-live"
                [title]="sitecore.globalMessages.NavLive"
                [boldTitle]="epcotEnable"
                [iconSize]="iconSize"
                [href]="liveUrl"
                [arrow]="arrow" />
            <ms-list-item [title]="sitecore.globalMessages.NavToday" [boldTitle]="epcotEnable" [href]="todayUrl" [arrow]="arrow">
                <span item-icon class="theme-current-date" [class.date-alignment]="!epcotEnable">
                    {{ today | date: 'MMM' }}<br />{{ today | date: 'dd' }}
                </span>
            </ms-list-item>
            <ms-list-item
                icon="sports-all"
                [title]="sitecore.globalMessages.NavAllSports"
                [boldTitle]="epcotEnable"
                [iconSize]="iconSize"
                [href]="allUrl"
                [arrow]="arrow" />
            <ms-list-item
                icon="theme-home"
                [title]="sitecore.globalMessages.NavHome"
                [boldTitle]="epcotEnable"
                [iconSize]="iconSize"
                [href]="homeUrl"
                [arrow]="arrow"
                [isShowBorder]="false" />
        </div>
    }
</div>
